// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
class CustomEventStub {
    constructor(detail = null) {
        this.detail = detail;
        this.defaultPrevented = false;
        this.cancelBubble = false;
    }
    preventDefault() {
        // noop
    }
    stopPropagation() {
        // noop
    }
}
export function createCustomEvent(detail) {
    return new CustomEventStub(detail);
}
//# sourceMappingURL=events.js.map